"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Services.TopicUpdate
 */
/**
 * Write a {@link NoValue} update constraint to the stream
 */
function write() {
    // no-op, write nothing
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/no-value-serialiser.js
// module id = 1426
// module chunks = 1